import { Typography, Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

function FormDisclosure({ label, children }) {
  return (
    <Accordion variant="outlined">
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: 'grey.100' }}>
        <Typography fontWeight={600}>{label}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 2.5 }}>
        <Grid container spacing={2}>
          {children}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default FormDisclosure;
